const initialState = (function(state){
	return state || {};
})(window.commentstate.user);

export default function(state=initialState, action) {
	return state;
}